@if(isPageRestrictionLoaded) {
<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Invoice Payroll Processing</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-invoice-filter [filterFields]="filterFields" (searchEvent)="onSearch($event)"
                        [chequeNumbers]="chequeNumbers" [pageId]="pageId"></ppl-invoice-filter>
                    <p class="pl-2"> <span class="error-message">*</span> Atleast one out of the following fields should
                        be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.</p>
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <div class="grid-toolbar">
                        <ppl-button label="Submit to Payroll" icon="fa fa-check" [customClass]="'primary-button'"
                            [iconPosition]="'left'" [disabled]="!selectedLineItems.length"
                            (click)="openSubmitProcessing()"></ppl-button>
                    </div>
                    <ppl-list-table [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [enableActions]="false" [data]="invoices" (rowDetailEvent)="rowClicked($event)"
                        [disableSelection]="true" [cols]="cols" (gridAction)="onAction($event)" [gridTitle]="false"
                        [pagination]="true" [loadPage]="true" [customDataLoaded]="true" [customDataHasUnknownTotal]="false" (onPageLoad)="onPageLoad($event)"
                        [showExpandIcon]="true" [showLineItem]="true" [lineItemCols]="lineItemCols"
                        [enableLineItemSelection]="true" (lineItemSelectionChanged)="onLineItemSelection($event)"
                        [from]="'invoices'">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>
}

<div class="filter-panel">
    <ng-template #addInvoiceDialog let-cancel="cancel">
        <ppl-add-invoice [mode]="mode" [invoiceId]="invoiceId" [providerId]="selectedLineItem?.providerId"
            [consumerId]="selectedLineItem?.consumerId" (invoiceSaved)="handleCancel($event)"
            (cancel)="handleCancel($event)" [staffView]="true" [isReadOnly]="true"></ppl-add-invoice>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #submitProcessingDialog>
        <form nz-form [formGroup]="processingForm" class="submit-processing-form">
            <div nz-row [nzGutter]="16">
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label nzRequired>From Date</nz-form-label>
                        <nz-form-control [nzErrorTip]="'Please select a from date'">
                            <nz-date-picker formControlName="fromDate" nzFormat="MM/dd/yyyy"
                                style="width: 100%;"></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label nzRequired>To Date</nz-form-label>
                        <nz-form-control [nzErrorTip]="'Please select a to date'">
                            <nz-date-picker formControlName="toDate" nzFormat="MM/dd/yyyy"
                                style="width: 100%;"></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
                <div nz-col [nzSpan]="12">
                    <nz-form-item>
                        <nz-form-label nzRequired>Check Date</nz-form-label>
                        <nz-form-control [nzErrorTip]="'Please select a check date'">
                            <nz-date-picker formControlName="checkDate" nzFormat="MM/dd/yyyy"
                                style="width: 100%;"></nz-date-picker>
                        </nz-form-control>
                    </nz-form-item>
                </div>
            </div>
            <div class="dialog-actions">
                <ppl-button label="Cancel" [customClass]="'ghost-button'" (click)="closeSubmitProcessing()"></ppl-button>
                <ppl-button label="Submit" [customClass]="'primary-button'" [disabled]="processingForm.invalid"
                    (click)="submitProcessing()"></ppl-button>
            </div>
        </form>
    </ng-template>
</div>
